import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaPhoneAlt, 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaBuilding, 
  FaClock, 
  FaBoxOpen, 
  FaHandshake, 
  FaMoneyBillWave, 
  FaIndustry, 
  FaQuestionCircle, 
  FaHeadset 
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const faqs = [
    {
      question: 'What are your business hours?',
      answer: 'We are open Monday to Saturday, 9:00 AM to 6:00 PM. We are closed on Sundays and public holidays.'
    },
    {
      question: 'How can I place a bulk order?',
      answer: 'You can contact us via WhatsApp or phone to discuss bulk orders. Our team will provide pricing and delivery details.'
    },
    {
      question: 'Do you provide delivery?',
      answer: 'Yes, we provide delivery services within our distribution network. Delivery terms depend on order size and location.'
    },
    {
      question: 'How can I become a distributor?',
      answer: 'Visit our "Become Distributor" page or contact us directly. Our team will guide you through the application process.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept bank transfers, UPI, and cash payments. Payment terms are discussed during order confirmation.'
    },
    {
      question: 'How can I verify product authenticity?',
      answer: 'All our products have proper labeling with batch numbers and manufacturing details. Contact us with the batch number for verification.'
    }
  ];

  return (
    <div className="contact-page">
      {/* Page Hero */}
      <section className="contact-hero">
        <div className="hero-bg">
          <img src="/Contact Page images/factory-location.jpg" alt="Contact Us" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="contact-hero-content">
            <span className="hero-badge"><FaPhoneAlt /> Get in Touch</span>
            <h1>Contact Us</h1>
            <p>We'd love to hear from you. Reach out for any queries or business inquiries.</p>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Contact</span>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact Cards */}
      <section className="quick-contact section">
        <div className="container">
          <div className="quick-contact-grid">
            <div className="quick-card phone">
              <div className="quick-icon"><FaPhoneAlt /></div>
              <h4>Call Us</h4>
              <p>
                <a href="tel:+918077894559">+91 8077894559</a>
                <br />
                <a href="tel:+917983864997">+91 79838 64997</a>
              </p>
              <span className="quick-action">Tap to Call</span>
            </div>
            <a 
              href="https://wa.me/918077894559?text=Hello, I would like to know more about Shikhar Dhara products."
              target="_blank"
              rel="noopener noreferrer"
              className="quick-card whatsapp"
              style={{marginBottom: '10px'}}
            >
              <div className="quick-icon"><FaWhatsapp /></div>
              <h4>WhatsApp</h4>
              <p>+91 8077894559</p>
              <span className="quick-action">Chat Now</span>
            </a>
            <a 
              href="https://wa.me/917983864997?text=Hello, I would like to know more about Shikhar Dhara products."
              target="_blank"
              rel="noopener noreferrer"
              className="quick-card whatsapp"
            >
              <div className="quick-icon"><FaWhatsapp /></div>
              <h4>WhatsApp</h4>
              <p>+91 79838 64997</p>
              <span className="quick-action">Chat Now</span>
            </a>
            <a href="mailto:info@shikhardhara.com" className="quick-card email">
              <div className="quick-icon"><FaEnvelope /></div>
              <h4>Email Us</h4>
              <p>info@shikhardhara.com</p>
              <span className="quick-action">Send Email</span>
            </a>
            <div className="quick-card location">
              <div className="quick-icon"><FaMapMarkerAlt /></div>
              <h4>Visit Us</h4>
              <p>Parsakhera Industrial Area, Bareilly</p>
              <span className="quick-action">View Location</span>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Details Section */}
      <section className="contact-details section bg-light">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Contact Information</h2>
              <p>
                Have questions about our products, distribution, or partnership 
                opportunities? Get in touch with us through any of the channels below.
              </p>
              
              <div className="contact-info-list sticky-content">
                <div className="contact-info-item">
                  <div className="info-icon"><FaBuilding /></div>
                  <div className="info-content">
                    <h4>Registered Address</h4>
                    <p>
                      UPSIDC Industrial Area, Building No. D-49,<br />
                      Road No. 1, Parsakhera Industrial Area,<br />
                      Bareilly, Uttar Pradesh – 243502
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="info-icon"><FaPhoneAlt /></div>
                  <div className="info-content">
                    <h4>Phone Numbers</h4>
                    <p>
                      <a href="tel:+918077894559">+91 8077894559</a>
                      <br />
                      <a href="tel:+917983864997">+91 79838 64997</a>
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="info-icon"><FaWhatsapp /></div>
                  <div className="info-content">
                    <h4>WhatsApp</h4>
                    <p>
                      <a 
                        href="https://wa.me/918077894559"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        +91 8077894559
                      </a>
                      <br />
                      <a 
                        href="https://wa.me/917983864997"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        +91 79838 64997
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="info-icon"><FaEnvelope /></div>
                  <div className="info-content">
                    <h4>Email Address</h4>
                    <p>
                      <a href="mailto:info@shikhardhara.com">info@shikhardhara.com</a>
                    </p>
                  </div>
                </div>
                
                <div className="contact-info-item">
                  <div className="info-icon"><FaClock /></div>
                  <div className="info-content">
                    <h4>Business Hours</h4>
                    <p>
                      Monday - Saturday: 9:00 AM - 6:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Map Section + Message Form */}
            <div className="map-column">
              <div className="map-section-wrapper">
                 <h2>Find Us</h2>
                 <div className="map-container">
                  <iframe
                    title="Shikhar Dhara Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3494.7982947428564!2d79.3800!3d28.3800!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDIyJzQ4LjAiTiA3OcKwMjInNDguMCJF!5e0!3m2!1sen!2sin!4v1640000000000!5m2!1sen!2sin"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                 </div>
                 <div className="map-actions">
                  <a 
                    href="https://www.google.com/maps/search/UPSIDC+Industrial+Area+Parsakhera+Bareilly"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    <FaMapMarkerAlt /> Get Directions
                  </a>
                 </div>
              </div>

              {/* Added Contact Form for visuals */}
              <div className="contact-form-card mt-4">
                 <h3>Send us a Message</h3>
                 <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group">
                       <input type="text" placeholder="Your Name" className="form-control" />
                    </div>
                    <div className="form-group">
                       <input type="text" placeholder="Phone Number" className="form-control" />
                    </div>
                    <div className="form-group">
                       <textarea placeholder="Your Message" rows="4" className="form-control"></textarea>
                    </div>
                    <button className="btn btn-primary w-100">Send Message</button>
                    <small className="form-note">We'll get back to you via WhatsApp or Phone.</small>
                 </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions */}
      <section className="quick-actions section">
        <div className="container">
          <div className="section-header">
            <h2>How Can We Help You?</h2>
            <p>Choose an option that best describes your inquiry</p>
          </div>
          
          <div className="actions-grid">
            <a 
              href="https://wa.me/918077894559?text=Hello, I want to place a bulk order for water bottles."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaBoxOpen /></div>
              <h4>Place Bulk Order</h4>
              <p>Order water or juice in bulk quantities</p>
            </a>
            <a 
              href="https://wa.me/918077894559?text=Hello, I am interested in becoming a distributor."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaHandshake /></div>
              <h4>Become Distributor</h4>
              <p>Join our distribution network</p>
            </a>
            <a 
              href="https://wa.me/918077894559?text=Hello, I need pricing information for your products."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaMoneyBillWave /></div>
              <h4>Get Pricing</h4>
              <p>Request product pricing details</p>
            </a>
            <a 
              href="https://wa.me/918077894559?text=Hello, I would like to schedule a facility visit."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaIndustry /></div>
              <h4>Factory Visit</h4>
              <p>Schedule a manufacturing facility tour</p>
            </a>
            <a 
              href="https://wa.me/918077894559?text=Hello, I have a general inquiry about your products."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaQuestionCircle /></div>
              <h4>General Inquiry</h4>
              <p>Any other questions or feedback</p>
            </a>
            <a 
              href="https://wa.me/918077894559?text=Hello, I need customer support assistance."
              target="_blank"
              rel="noopener noreferrer"
              className="action-card"
            >
              <div className="action-icon"><FaHeadset /></div>
              <h4>Customer Support</h4>
              <p>Get help with existing orders</p>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="contact-faq section bg-light">
        <div className="container">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
            <p>Quick answers to common questions</p>
          </div>
          
          <div className="faq-accordion">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-accordion-item">
                <h4 className="faq-question">{faq.question}</h4>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="contact-cta">
        <div className="container">
          <div className="contact-cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Contact us now for product inquiries, bulk orders, or partnership opportunities</p>
            <div className="contact-cta-buttons">
              <a 
                href="https://wa.me/918077894559?text=Hello, I am interested in Shikhar Dhara products."
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-whatsapp btn-lg"
              >
                <FaWhatsapp /> WhatsApp Us
              </a>
              <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center'}}>
                <a href="tel:+918077894559" className="btn btn-white btn-lg">
                  <FaPhoneAlt /> Call: +91 8077894559
                </a>
                <a href="tel:+917983864997" className="btn btn-white btn-lg">
                  <FaPhoneAlt /> Call: +91 79838 64997
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
